import { render } from "./company-policy.vue?vue&type=template&id=d993ab4e"
import script from "./company-policy.vue?vue&type=script&lang=js"
export * from "./company-policy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__